import validate from "/opt/buildhome/repo/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/opt/buildhome/repo/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  admin: () => import("/opt/buildhome/repo/middleware/admin.js"),
  auth: () => import("/opt/buildhome/repo/middleware/auth.js"),
  client: () => import("/opt/buildhome/repo/middleware/client.js"),
  guest: () => import("/opt/buildhome/repo/middleware/guest.js")
}